'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceSetupInformation = exports.DeviceSetupInformationUnwrapped = exports.mapStateToProps = exports.formConfig = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reduxForm = require('redux-form');

var _forms = require('helpers/forms');

var _video = require('constants/video');

var _deviceSetupModal = require('containers/DeviceSetupModal/device-setup-modal.saga');

var _InputField = require('../FormFields/InputField');

var _validators = require('./validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-array-index-key */

var getFormDates = function getFormDates() {
  var now = new Date();
  var defaultBirthYear = now.getFullYear() - _video.DEFAULT_AGE;
  var defaultBirthDate = new Date(defaultBirthYear, 0, 1);
  var maxBirthYear = now.getFullYear() - _video.MIN_AGE;
  var inputYearsCount = _video.MAX_AGE - (now.getFullYear() - maxBirthYear);
  return {
    defaultBirthDate: defaultBirthDate,
    inputYearsCount: inputYearsCount,
    maxBirthYear: maxBirthYear
  };
};

var formDates = getFormDates();

var formConfig = exports.formConfig = {
  form: 'device-setup',
  validate: _validators.validators
};

var getErrors = (0, _forms.getFormErrors)(formConfig.form);
var getValues = (0, _forms.getFormValues)(formConfig.form);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var userProfile = state.entities.userProfile.data.default;
  var birthDate = userProfile.date_of_birth ? new Date(userProfile.date_of_birth.split('-')) : formDates.defaultBirthDate;
  var errors = getErrors(state);
  var errorMessages = errors && {
    birthDate: errors.birthDateMonth || errors.birthDateDay || errors.birthDateYear,
    gender: errors.gender,
    weight: errors.weight
  } || {};

  return (0, _extends3.default)({
    errorMessages: errorMessages,
    initialValues: {
      gender: userProfile.gender,
      birthDateMonth: (birthDate.getMonth() + 1).toString(),
      birthDateDay: birthDate.getDate().toString(),
      birthDateYear: birthDate.getFullYear().toString(),
      weight: userProfile.weight && userProfile.weight.lb
    }
  }, formDates, getValues(state));
};

var DeviceSetupInformationUnwrapped = exports.DeviceSetupInformationUnwrapped = function (_React$Component) {
  (0, _inherits3.default)(DeviceSetupInformationUnwrapped, _React$Component);

  function DeviceSetupInformationUnwrapped() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, DeviceSetupInformationUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = DeviceSetupInformationUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(DeviceSetupInformationUnwrapped)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleSubmit = function (event) {
      var handleSubmit = _this.props.handleSubmit;


      handleSubmit(_deviceSetupModal.submitUserInformation)(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(DeviceSetupInformationUnwrapped, [{
    key: 'daysInMonth',
    value: function daysInMonth(month, year) {
      var mo = month || 0;
      var yr = year || 1970;
      return new Date(parseInt(yr, 10), parseInt(mo, 10) + 1, 0).getDate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          birthDateMonth = _props.birthDateMonth,
          birthDateYear = _props.birthDateYear,
          errorMessages = _props.errorMessages,
          inputYearsCount = _props.inputYearsCount,
          localMaxBirthYear = _props.maxBirthYear,
          submitting = _props.submitting;

      var daysInMonth = this.daysInMonth(birthDateMonth - 1, birthDateYear);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'modal__device-setup__top' },
          _react2.default.createElement(
            'h3',
            { className: 'mv' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'device.info.header',
              defaultMessage: 'Enter your details'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'p-' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'device.info.copy',
              defaultMessage: 'We use your personal information to determine your heart rate zones and calorie burn. This makes your workout as effective as possible.',
              tagName: 'p'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'modal__device-setup__content' },
          _react2.default.createElement(
            'form',
            { onSubmit: this.handleSubmit, autoComplete: 'on', className: 'modal__device-information__form' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'label',
                { htmlFor: 'gender', className: 'modal__device-information__label mb-' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'gender',
                  defaultMessage: 'Gender'
                })
              ),
              _react2.default.createElement(
                _reduxForm.Field,
                {
                  name: 'gender',
                  component: _InputField.InputField,
                  inputClassNames: 'modal__device-information__select',
                  inputTag: 'select',
                  suppressErrorMessage: true
                },
                _react2.default.createElement(
                  'option',
                  { value: '' },
                  'Select'
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'Female' },
                  'Female'
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'Male' },
                  'Male'
                )
              )
            ),
            errorMessages.gender && _react2.default.createElement(
              'div',
              { id: 'error-gender', className: 'error__text text--sm mt-' },
              _react2.default.createElement(_reactIntl.FormattedMessage, errorMessages.gender)
            ),
            _react2.default.createElement(
              'fieldset',
              { className: 'mt+' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'birthday', className: 'modal__device-information__label mb-' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'device-setup.dob',
                  defaultMessage: 'Date of birth'
                })
              ),
              _react2.default.createElement(
                _reduxForm.Field,
                {
                  name: 'birthDateMonth',
                  component: _InputField.InputField,
                  inputTag: 'select',
                  wrapperTag: 'span',
                  inputClassNames: 'modal__device-information__select mr-',
                  suppressErrorMessage: true
                },
                ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map(function (val, idx) {
                  return _react2.default.createElement(
                    'option',
                    { key: 'month' + idx, value: idx + 1 },
                    val
                  );
                })
              ),
              _react2.default.createElement(
                _reduxForm.Field,
                {
                  name: 'birthDateDay',
                  component: _InputField.InputField,
                  inputTag: 'select',
                  wrapperTag: 'span',
                  inputClassNames: 'modal__device-information__select mr-',
                  suppressErrorMessage: true
                },
                [].concat((0, _toConsumableArray3.default)(Array(daysInMonth))).map(function (val, idx) {
                  return _react2.default.createElement(
                    'option',
                    { key: 'day' + idx, value: idx + 1 },
                    idx + 1
                  );
                })
              ),
              _react2.default.createElement(
                _reduxForm.Field,
                {
                  name: 'birthDateYear',
                  component: _InputField.InputField,
                  inputTag: 'select',
                  wrapperTag: 'span',
                  inputClassNames: 'modal__device-information__select mr-',
                  suppressErrorMessage: true
                },
                [].concat((0, _toConsumableArray3.default)(Array(inputYearsCount))).map(function (val, idx) {
                  return _react2.default.createElement(
                    'option',
                    { key: 'year' + idx, value: localMaxBirthYear - idx },
                    localMaxBirthYear - idx
                  );
                })
              )
            ),
            errorMessages.birthDate && _react2.default.createElement(
              'div',
              { id: 'error-birth-date', className: 'error__text text--sm mt-' },
              _react2.default.createElement(_reactIntl.FormattedMessage, errorMessages.birthDate)
            ),
            _react2.default.createElement(
              'div',
              { className: 'modal__device-setup__weight-container mt+ mb-' },
              _react2.default.createElement(_reduxForm.Field, {
                suppressErrorMessage: true,
                component: _InputField.InputField,
                name: 'weight',
                inputAttributes: {
                  autoComplete: 'weight',
                  maxLength: '3'
                },
                wrapperAttributes: {
                  className: 'inline-block mr-'
                },
                inputClassNames: 'modal__device-setup__weight inline-block',
                label: _react2.default.createElement(
                  'span',
                  { className: 'modal__device-information__label mb-' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'device-setup.weight',
                    defaultMessage: 'Weight'
                  })
                )
              }),
              _react2.default.createElement(
                'span',
                { className: 'modal__device-setup__weight-unit inline-block' },
                'lbs'
              )
            ),
            errorMessages.weight && _react2.default.createElement(
              'div',
              { id: 'error-weight', className: 'error__text text--sm mt-' },
              _react2.default.createElement(_reactIntl.FormattedMessage, errorMessages.weight)
            ),
            _react2.default.createElement(
              'div',
              { className: 'text--center' },
              _react2.default.createElement(
                'button',
                {
                  disabled: submitting,
                  type: 'submit',
                  className: 'bt bt--primary bt--width-md grid__item mt+'
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'modal.next',
                  defaultMessage: 'Next'
                })
              )
            )
          )
        )
      );
    }
  }]);
  return DeviceSetupInformationUnwrapped;
}(_react2.default.Component);

DeviceSetupInformationUnwrapped.propTypes = {
  birthDateMonth: _propTypes2.default.string,
  birthDateYear: _propTypes2.default.string,
  errorMessages: _propTypes2.default.object.isRequired,
  inputYearsCount: _propTypes2.default.number.isRequired,
  handleSubmit: _propTypes2.default.func,
  maxBirthYear: _propTypes2.default.number,
  submitting: _propTypes2.default.bool
};

var DeviceSetupInformation = exports.DeviceSetupInformation = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(formConfig)(DeviceSetupInformationUnwrapped));